import { z } from 'zod';
import { Prisma } from './generated/index.js';

export type CreateLocaleDto = Omit<
  Prisma.LocaleCreateInput,
  'createdAt' | 'updatedAt' | 'users' | 'cgus' | 'interviews' | 'cvs'
>;

export type UpdateLocaleDto = Partial<Omit<CreateLocaleDto, 'codeLong' | 'codeShort'>>;

// Direction types for RTL/LTR support
export type LocaleDirection = 'rtl' | 'ltr';

export enum AudioMessageKeyEnum {
  WELCOME = 'welcomeMessage',
  FEEDBACK_CATEGORIES_INTRO = 'feedback_categories_intro',
  FEEDBACK_LANGUAGE_CHANGED = 'feedback_language_changed',
  FEEDBACK_CATEGORY_CONFIRM = 'feedback_category_confirm',
  FEEDBACK_RECORD_RULES = 'feedback_record_rules',
  FEEDBACK_RECORDING_ACTIVE = 'feedback_recording_active',
  FEEDBACK_RECORDING_ENDING = 'feedback_recording_ending',
  FEEDBACK_CLIP_SAVED = 'feedback_clip_saved',
  FEEDBACK_RECORD_SILENCE = 'feedback_record_silence',
  FEEDBACK_MIC_UNAVAILABLE = 'feedback_mic_unavailable',
  FEEDBACK_CLIP_DELETE_CONFIRM = 'feedback_clip_delete_confirm',
  FEEDBACK_READY_TO_SEND = 'feedback_ready_to_send',
  FEEDBACK_QUEUED_OFFLINE = 'feedback_queued_offline',
  FEEDBACK_SENT_ONLINE = 'feedback_sent_online',
  FEEDBACK_SENT_AFTER_SYNC = 'feedback_sent_after_sync',
}

export const localesQueryDtoSchema = z.object({
  page: z.coerce.number().int().positive().default(1).optional(),
  limit: z.coerce.number().int().positive().max(100).default(10).optional(),
});

export type LocalesQueryDto = z.infer<typeof localesQueryDtoSchema>;
